import req from "../../../services/psikotest/request";

class BrsFormula {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/brs_formula/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSBrsFormula) {
    try {
      const res = await req.post("/api/psikotest_system/brs_formula/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSBrsFormula) {
    try {
      const res = await req.put("/api/psikotest_system/brs_formula/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/brs_formula/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default BrsFormula;
